import { ZONE1_POSITIONS } from '../zones/zone1/Zone1Map';
import { ZONE2_POSITIONS } from '../zones/zone2/Zone2Map';
import { ZONE3_POSITIONS } from '../zones/zone3/Zone3Map';
import { ZONE4_POSITIONS } from '../zones/zone4/Zone4Map';
import { ZONE5_POSITIONS } from '../zones/zone5/Zone5Map';
import type { SavePosition } from '../systems/SaveSystem';
import { SCENE_KEYS } from './gameConstants';

const ZONE_SPAWNS: Record<string, SavePosition> = {
  [SCENE_KEYS.ZONE1]: ZONE1_POSITIONS.SPAWN,
  [SCENE_KEYS.ZONE2]: ZONE2_POSITIONS.SPAWN,
  [SCENE_KEYS.ZONE3]: ZONE3_POSITIONS.SPAWN,
  [SCENE_KEYS.ZONE4]: ZONE4_POSITIONS.SPAWN,
  [SCENE_KEYS.ZONE5]: ZONE5_POSITIONS.SPAWN,
};

export function getZoneSpawn(sceneKey: string): SavePosition | null {
  return ZONE_SPAWNS[sceneKey] ?? null;
}
